import React from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Tabs } from '@material-ui/core';
import { Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';

import { backNavigationStore } from 'stores';
import { AppBar, Page, TabLink } from 'components';
import { ru } from 'locale';
import { getLastUrlSegment } from 'utils/string';
import { GuarantorList, PropertiesList } from './components';
import { tabs } from './GuarantorsScreen.mock';

const GuarantorsScreen = observer(() => {
  const { backUrl } = backNavigationStore;
  const { pathname } = useLocation();
  const activeTab = getLastUrlSegment(pathname);
  const history = useHistory();
  const { path } = useRouteMatch();

  const handleBackClick = () => {
    history.goBack();
  };

  const a11yProps = id => {
    return {
      id,
      value: id,
      'aria-controls': `guarantor-tabpanel-${id}`,
    };
  };

  const renderTabContent = () => {
    return (
      <>
        <Route path={`${path}/guarantors`} exact>
          <GuarantorList />
        </Route>
        <Route path={`${path}/properties`} exact>
          <PropertiesList />
        </Route>
      </>
    );
  };

  const renderTabs = () => {
    return (
      <Tabs aria-label={ru.guarantors} value={activeTab}>
        {tabs.map(tab => (
          <TabLink key={tab.value} label={tab.label} {...a11yProps(tab.value)} />
        ))}
      </Tabs>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <AppBar
          title={ru.assuranceAndGuarantor}
          onNavButtonClick={handleBackClick}
          additionalSlot={renderTabs()}
          backUrl={`${backUrl}#gp`}
          typeNavIcon="link"
        />

        {renderTabContent()}
      </Grid>
    </Page>
  );
});

export default GuarantorsScreen;
